// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/sidebar.js
import BaseComponent from "./base_component"

export default class Sidebar extends BaseComponent {
  static componentName = "sidebar"

  constructor(element, config = {}) {
    super(element, config)
    this.listen(element, "click", (event) => {
      const toggler = event.target.closest('[data-coreui-toggle="narrow"], [data-coreui-toggle="unfoldable"]')
      if (!toggler) return
      event.preventDefault()
      toggler.dataset.coreuiToggle === "narrow" ? this.toggleNarrow() : this.toggleUnfoldable()
    })
    this.listen(element, "keydown", (event) => {
      if (event.key === "Escape" && this.mobile()) this.hide()
    })
    this.listen(window, "resize", () => {
      if (this.mobile() && element.classList.contains("show")) this.hide()
    })
  }

  mobile() {
    const flag = getComputedStyle(this.element).getPropertyValue("--cui-is-mobile").trim()
    return flag !== "" && flag !== "0" && flag !== "false"
  }

  visible() {
    if (this.element.classList.contains("sidebar-overlaid") || this.mobile())
      return this.element.classList.contains("show")
    return !this.element.classList.contains("hide")
  }

  show() {
    if (this.visible() || this.emit("show", {}, { cancelable: true }).defaultPrevented) return
    this.element.classList.remove("hide")
    if (this.mobile() || this.element.classList.contains("sidebar-overlaid")) this.element.classList.add("show")
    if (this.mobile()) this.showBackdrop()
    this.emit("shown")
  }

  hide() {
    if (!this.visible() || this.emit("hide", {}, { cancelable: true }).defaultPrevented) return
    this.element.classList.remove("show")
    if (!this.mobile() && !this.element.classList.contains("sidebar-overlaid")) this.element.classList.add("hide")
    this.removeBackdrop()
    this.emit("hidden")
  }

  toggle() {
    this.visible() ? this.hide() : this.show()
  }

  showBackdrop() {
    if (this.backdrop) return
    this.backdrop = document.createElement("div")
    this.backdrop.className = "sidebar-backdrop fade show"
    this.element.parentElement?.append(this.backdrop)
    this.listen(this.backdrop, "click", () => this.hide())
  }

  removeBackdrop() {
    this.backdrop?.remove()
    this.backdrop = null
  }

  toggleNarrow() {
    this.element.classList.toggle("sidebar-narrow")
    this.element.classList.remove("sidebar-narrow-unfoldable")
  }

  toggleUnfoldable() {
    this.element.classList.toggle("sidebar-narrow-unfoldable")
    this.element.classList.remove("sidebar-narrow")
  }

  dispose() {
    if (this.signal.aborted) return
    this.removeBackdrop()
    if (this.mobile() || this.element.classList.contains("sidebar-overlaid")) this.element.classList.remove("show")
    super.dispose()
  }
}
